import { AsyncAction } from 'src/utils/reduxUtils'
import { ApiService, callClientSecureApi } from './api/callApi'
import { call, put, takeLatest } from 'redux-saga/effects'
import { Endpoints } from 'src/constants/endpoints'
import { FetchDriver, UploadBankInformation } from 'src/constants/actionTypes'
import { PaymentMethodTypeEnum, RecipientTypeEnum } from 'src/interfaces/paymentMethod'

interface BankInformationRequest {
  routingNumber: string
  accountNumber: string
  accountType: string
  stepId: string
  hasBusinessEntity: boolean
}

function* onUploadBankInformation(action: AsyncAction<BankInformationRequest>) {
  const { routingNumber, accountNumber, accountType, stepId, hasBusinessEntity } = action.payload

  try {
    yield call(callClientSecureApi, Endpoints.UploadPaymentMethod, {
      method: 'POST',
      body: {
        stepId,
        paymentMethodType: PaymentMethodTypeEnum.BankAccount,
        bankAccountDetails: {
          recipientType: hasBusinessEntity
            ? RecipientTypeEnum.Business
            : RecipientTypeEnum.Individual,
          routingNumber,
          accountNumber,
          accountType,
        },
      },
      apiService: ApiService.Paraworks,
    })

    yield put(UploadBankInformation.success())

    yield put(FetchDriver.request())

    if (action.next) {
      action.next(null)
    }
  } catch (err: any) {
    const errorMessage = err?.payload?.message || 'Failed to upload bank information'

    yield put(UploadBankInformation.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* bankInformationSaga() {
  yield takeLatest(UploadBankInformation.type.REQUEST, onUploadBankInformation)
}
